import { IToast } from '@chakra-ui/react'
import { UploadFile } from '../generated/graphql'
export const APP_NAME = 'Nsoko Property'
export const AUTHOR = 'Nsoko LTD'
export const API_HOST = process.env.REACT_APP_API_HOST || ''
export const NSOKO_PHONE_NUMBER = '27-682-135-860'
export const TIME_FORMAT = 'hh:mm:ss A'
export const REFETCH_DELAY_TIME = 900000
export const DEFAULT_INTEREST_MESSAGE =
  'Je suis intéressé par cette propriete, merci de me contacter.'
export const DEFAULT_SELLER_MESSAGE = 'Je souhaite vendre mon bien, merci de me contacter.'
export const STRAPI_USER_STORAGE_KEY = 'strapi-user'
export const RECENT_SEARCHED_LOCATIONS_STORAGE_KEY = 'recent-searched-locations'
export const LAST_SELECTED_FILTERS_STORAGE_KEY = 'last-selected-filter'
export const USER_GEOLOCATION_STORAGE_KEY = 'user-geolocation'
export const ADMIN_DEFAULT_VIEW = 'admin-default-view'
export const ADMIN_MODE_STORAGE_KEY = 'x'
export const LANGUAGE_STORAGE_KEY = 'lng'
export const CLIENT_HOST = process.env.REACT_APP_CLIENT_HOST
export const LARGEST_PRICE = '100000000000000'
export const AGENT_TYPE = 'agent'
export const AGENCY_TYPE = 'agency'
export const CLIENT_TYPE = 'client'
export const ADMIN_TYPE = 'admin'
export const CONTACT_SUPPORT_FORM_ID = 'rWq31kla'

// Development
export const IS_PROD = process.env.NODE_ENV === 'production'

export const PASSWORD_REGEX_MESSAGE =
  'Password must contain at least 1 lowercase letter, 1 uppercase letter, 1' +
  ' number and 1 special character'

export const SUCCESS_TOAST: IToast = {
  duration: 6000,
  isClosable: true,
  title: 'Success!',
  status: 'success',
  position: 'top-right'
}

export const ERROR_TOAST: IToast = {
  duration: 6000,
  title: 'Oops!',

  status: 'error',
  isClosable: true,
  position: 'top-right'
}

export const LANGUAGES = [
  {
    name: 'English',
    code: 'en',
    icon: '🏴󠁧󠁢󠁥󠁮󠁧󠁿'
  },
  {
    name: 'Français',
    code: 'fr',
    icon: '🇫🇷'
  }
]
export const MAX_ROOM_AMOUT = 15

export const DATE_FORMAT = 'DD/MM/YYYY'

export const PHONE_NUMBER_REGEX = new RegExp('^\\+?[0-9]{8,}$')

export const COUNTRY_CODE = '+27'

export const EMPTY_FILE: UploadFile = {
  id: '',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  name: '',
  hash: '',
  mime: '',
  size: 0,
  url: '',
  provider: ''
}

export const WARNING_TOAST: IToast = {
  duration: 6000,
  title: 'Oops!',
  status: 'warning',
  isClosable: true,
  position: 'bottom-right'
}

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY || ''

export const MENU1_WIDTH = 230
export const MENU2_WIDTH = 380

export const CURRENCY_MAP = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  CAD: '$',
  AUD: '$',
  NZD: '$',
  CHF: 'CHF',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  RUB: '₽',
  INR: '₹',
  BRL: 'R$',
  ZAR: 'R',
  TRY: '₺',
  PLN: 'zł',
  SGD: '$',
  HKD: '$',
  KRW: '₩',
  MXN: '$',
  PHP: '₱',
  TWD: 'NT$',
  THB: '฿',
  IDR: 'Rp',
  HUF: 'Ft',
  CZK: 'Kč',
  ILS: '₪',
  CLP: '$',
  AED: 'د.إ',
  SAR: 'ر.س',
  RON: 'lei',
  MYR: 'RM',
  NGN: '₦',
  ARS: '$',
  COP: '$',
  PEN: 'S/',
  VND: '₫',
  EGP: '£',
  PKR: '₨',
  IQD: 'ع.د',
  KWD: 'د.ك',
  OMR: 'ر.ع.',
  QAR: 'ر.ق',
  CUC: '$',
  BOB: '$b',
  DZD: 'د.ج',
  MAD: 'د.م.',
  BHD: '.د.ب',
  LYD: 'ل.د',
  TND: 'د.ت',
  GHS: '₵',
  AOA: 'Kz',
  UYU: '$U',
  AFN: '؋',
  LKR: '₨',
  BDT: '৳',
  HTG: 'G',
  PYG: 'Gs',
  NPR: '₨',
  CDF: 'FC',
  SDG: '£',
  GTQ: 'Q',
  RSD: 'Дин.',
  XAF: 'FCFA',
  XOF: 'CFA',
  JMD: 'J$',
  KES: 'KSh',
  PGK: 'K'
}
